import type { Context } from 'react';
import { useContext } from 'react';

export function useContextOrThrow<T>(
  context: Context<T>,
  contextName: string
): NonNullable<T> {
  const contextValue = useContext(context);

  if (contextValue === undefined || contextValue === null) {
    throw new Error(
      `use${contextName} must be used within a ${contextName}Provider.`
    );
  }

  return contextValue;
}
